/**
* Exposed CSS variables
*
* @prop --select-option-font-size: The font size of the select option default is `0.875rem`
* @prop --select-option-padding: The padding of the select option default is `0.5rem 0.75rem`
* @prop --select-option-radius: The border radius of the select option default is `0.35rem`
* @prop --select-option-weight: The font weight of the select option default is `500`
*/

$light: #ffffff;

:host {
  display: block;
  font-size: var(--select-option-font-size, 0.875rem);
  padding: var(--select-option-padding, 0.5rem 0.75rem);
  position: relative;
  padding-left: 1.75rem;
  padding-right: 0;
  cursor: pointer;
  border-radius: var(--select-option-radius, 0.35rem);
  font-weight: var(--select-option-weight, 500);
}

:host(:not([disabled]):is(:hover, :focus-visible)) {
  background: darken($color: $light, $amount: 6);
  outline: none;
}

:host(.selected)::before {
  content: '';
  display: block;
  position: absolute;
  inset: 0;
  width: 1.5rem;
}
:host(.selected.selected-style-checkmark)::before {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M20 6L9 17l-5-5'/%3E%3C/svg%3E")
    no-repeat center;
  background-size: 1rem;
}
:host(.selected.selected-style-checkRounded)::before {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z' clip-rule='evenodd'/%3E%3C/svg%3E")
    no-repeat center;
  background-size: 1rem;
}
:host(.selected.selected-style-dot)::before {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='6' fill='black'/%3E%3C/svg%3E")
    no-repeat center;
  background-size: 1rem;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.5;
}
